<template>
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>{{ $t("audit." + acKey + ".title") }}</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                class="btn"
                                size="x-small"
                                icon="$oss-chat"
                            >
                            </v-btn>
                        </template>
                        <span>Message</span>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod ||
                            validated ||
                            loading ||
                            dataLoading ||
                            !acKey ||
                            !accountingPeriod
                        "
                        @click="createGrossSalaryMatchData()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            disabledBtnGlobalValidation ||
                            loading ||
                            dataLoading ||
                            !acKey ||
                            !accountingPeriod
                        "
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading ||
                                !acKey
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                createGrossSalaryMatchData('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading ||
                                !acKey
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                createGrossSalaryMatchData('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <template v-if="!showDeleteAcrBtnIfRecovery">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <div no-gutters v-bind="props">
                                            <v-list-item no-gutters disabled>
                                                <v-list-item-title>
                                                    Supprimer le contrôle
                                                </v-list-item-title>

                                                <template v-slot:append>
                                                    <v-icon size="small"> $oss-trash </v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <span>{{ showDeleteAcrBtnTooltipMessage }}</span>
                                </v-tooltip>
                            </template>

                            <template v-else>
                                <v-list-item
                                    no-gutters
                                    @click="deleteAuditCheckResultDialog = true"
                                >
                                    <v-list-item-title> Supprimer le contrôle </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon>$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template v-else>
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <v-row no-gutters v-if="noResults">
                    <v-col cols="12" class="d-flex justify-center">
                        <h3>Aucune écriture enregistrée sur l'exercice fiscal sélectionné</h3>
                    </v-col>
                </v-row>

                <!-- // +++++ accountableAccount view, collapsed -->
                <v-card
                    v-for="(accountableAccount, i) in accountableAccounts"
                    :key="i"
                    v-show="accountableAccount.queryLength > 0"
                    style="background-color: white; border-radius: 25px"
                    class="my-2 pa-4"
                    elevation="0"
                >
                    <!-- // ** show even if totalBalance === 0 -->
                    <!-- // ** because accountingLines -->
                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="4">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col>
                                    <h3 v-if="accountableAccount.name" class="pl-4">
                                        {{ accountableAccount.name }}
                                    </h3>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="d-flex align-center">
                                <v-col>
                                    <h3 v-if="accountableAccount.description" class="pl-4 pt-2">
                                        {{ accountableAccount.description }}
                                    </h3>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="2" class="pr-10">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="d-flex justify-end">
                                    <h3 class="pl-4">Solde comptable</h3>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="d-flex justify-end">
                                    <h3 class="pl-4 pt-2" v-if="accountableAccount.totalBalance">
                                        {{
                                            newCommonFormatCurrency(
                                                accountableAccount.totalBalance,
                                                { currency: "", DC: true },
                                            )
                                        }}
                                    </h3>
                                    <h3 class="pl-4 pt-2" v-else>- &#x20ac;</h3>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="3" class="pr-10">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="d-flex justify-end">
                                    <h3>Vérification extra-comptable</h3>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="d-flex justify-end">
                                    <oss-text-field-filled
                                        v-model="accountableAccount.manualAmount"
                                        @update:model-value="changeGap(i)"
                                        class="d-flex justify-end"
                                        autofocus
                                        hideDetails
                                    >
                                    </oss-text-field-filled>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="2" class="pr-10">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="d-flex justify-end">
                                    <h3 class="pl-4">&#xc9;cart</h3>
                                </v-col>
                            </v-row>

                            <v-row no-gutters class="d-flex align-center">
                                <v-col class="d-flex justify-end">
                                    <h3
                                        class="pl-4 pt-2"
                                        v-if="
                                            accountableAccount.gap > 2 ||
                                            accountableAccount.gap < -2
                                        "
                                        style="color: #e9273c"
                                    >
                                        {{
                                            newCommonFormatCurrency(accountableAccount.gap, {
                                                currency: "",
                                                DC: true,
                                            })
                                        }}
                                    </h3>

                                    <!-- <h3 class="mr-auto pl-4 pt-2"
                                        v-else-if="accountableAccount.gap === 0"
                                    >
                                        {{accountableAccount.gap}} €
                                    </h3> -->

                                    <h3 v-else class="pl-4 pt-2">
                                        {{
                                            newCommonFormatCurrency(accountableAccount.gap, {
                                                currency: "",
                                                DC: true,
                                            })
                                        }}
                                    </h3>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="1">
                            <v-row no-gutters class="d-flex align-center">
                                <v-col cols="6">
                                    <v-icon
                                        v-if="accountableAccount.validated"
                                        class="text-primary"
                                        icon="$check_circle"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-btn-icon
                                        :icon="
                                            accountableAccount.expand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="aaExpand(accountableAccount)"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="accountableAccount.expand" transition="expand">
                        <!-- // // switchs generalLedger -->
                        <!-- <v-row no-gutters>
                            <v-col>
                                <v-switch inset v-model="withoutLettering" :label="'Cacher les éléments léttrés'" class="ml-2"></v-switch>
                            </v-col>
                            <v-col>
                                <v-switch inset v-model="withoutBank" :label="'Cacher la trésorerie'" class="ml-2"></v-switch>
                            </v-col>
                            <v-col>
                                <v-switch inset v-model="withoutDocument" :label="'Cacher les justificatifs'" class="ml-2"></v-switch>
                            </v-col>
                        </v-row> -->

                        <v-row>
                            <v-col cols="12">
                                <AccountableAccountBalanceDetail
                                    v-bind:companyId="companyId"
                                    v-bind:accountingPeriodId="accountingPeriodId"
                                    v-bind:accountableAccountInfo="
                                        accountableAccount.accountableAccountInfo
                                    "
                                    :userId="currentUser.id"
                                    v-bind:notReconciliated="withoutLettering"
                                    v-bind:withoutBank="withoutBank"
                                    v-bind:withoutDocument="withoutDocument"
                                    v-bind:inAccountingTransactions="accountingTransactions"
                                    @query-done="fetchTotals"
                                    v-show="
                                        accountableAccount.queryLength &&
                                        accountableAccount.queryLength > 0
                                    "
                                >
                                </AccountableAccountBalanceDetail>
                            </v-col>
                        </v-row>

                        <!-- // +++++++++++++++ textarea ++++++++++++++++ -->
                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-row no-gutters>
                                        <v-col cols="6">
                                            <h5>Commentaires</h5>
                                        </v-col>

                                        <v-col cols="6" class="d-flex justify-end">
                                            <!-- // ** btn solder écart -->
                                            <v-btn
                                                v-if="
                                                    accountableAccount.gap <= 2 &&
                                                    accountableAccount.gap >= -2 &&
                                                    accountableAccount.gap !== 0 &&
                                                    accountingPeriod &&
                                                    !accountingPeriod.closed
                                                "
                                                @click.stop="
                                                    miscellaneousOperationDialog = true;
                                                    createRows(accountableAccount);
                                                "
                                                size="small"
                                                class="px-2 mx-1"
                                            >
                                                Solder <v-icon>$not_equal</v-icon>
                                            </v-btn>

                                            <v-btn v-else disabled size="small" class="px-2 mx-1">
                                                Solder <v-icon>$not_equal</v-icon>
                                            </v-btn>
                                            <!-- <v-btn
                                            v-if="accountableAccount.gap <= 2 && accountableAccount.gap >= -2 && accountableAccount.gap !== 0"
                                            rounded
                                            size="small"

                                            color="primary"
                                            class="btn btn_blue"
                                            @click.stop="createGrossSalaryMatchData(); miscellaneousOperationDialog=true; createRows(accountableAccount)"
                                        >
                                            Solder  <v-icon>$not_equal</v-icon>
                                        </v-btn> -->
                                            <!-- <v-btn
                                            v-else
                                            disabled
                                            rounded
                                            size="small"
                                            color="primary"
                                            class="btn btn_blue"
                                        >
                                            Solder  <v-icon>$not_equal</v-icon>
                                        </v-btn> -->

                                            <!-- // ** OD -->
                                            <v-btn
                                                v-if="
                                                    accountableAccount.gap === 0 ||
                                                    closedPeriod ||
                                                    accountableAccount.validated
                                                "
                                                disabled
                                                size="small"
                                                class="px-2 mx-1"
                                            >
                                                OD
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                @click="
                                                    miscellaneousOperationDialog = true;
                                                    createRows(accountableAccount);
                                                "
                                                size="small"
                                                class="px-2 mx-1"
                                            >
                                                OD
                                            </v-btn>

                                            <v-btn
                                                v-if="closedPeriod || accountableAccount.validated"
                                                disabled
                                                size="small"
                                                class="px-2 mx-1"
                                            >
                                                Enregistrer
                                            </v-btn>

                                            <v-btn
                                                v-else-if="
                                                    accountableAccount.manualAmount ||
                                                    accountableAccount.comment
                                                "
                                                @click.stop="createGrossSalaryMatchData()"
                                                size="small"
                                                class="px-2 mx-1"
                                            >
                                                Enregistrer
                                            </v-btn>

                                            <v-btn v-else disabled size="small" class="px-2 mx-1">
                                                Enregistrer
                                            </v-btn>

                                            <v-btn
                                                v-if="
                                                    !accountableAccount.validated &&
                                                    accountableAccount.manualAmount &&
                                                    accountableAccount.gap <= 2 &&
                                                    accountableAccount.gap >= -2
                                                "
                                                @click="
                                                    accountableAccount.validated =
                                                        !accountableAccount.validated;
                                                    accountableAccount.expand = false;
                                                    createGrossSalaryMatchData('VALIDATE');
                                                "
                                                size="small"
                                                class="px-2 ml-1"
                                            >
                                                Valider
                                            </v-btn>

                                            <v-btn
                                                v-else-if="!accountableAccount.validated"
                                                disabled
                                                size="small"
                                                class="px-2 ml-1"
                                            >
                                                Valider
                                            </v-btn>

                                            <v-btn
                                                v-else
                                                @click="
                                                    accountableAccount.validated =
                                                        !accountableAccount.validated;
                                                    createGrossSalaryMatchData('UPDATE');
                                                "
                                                size="small"
                                                class="px-2 ml-1"
                                            >
                                                Invalider
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                            </v-col>
                        </v-row>

                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="accountableAccount.comment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="height: auto; border: 1px #ededed solid"
                                        outlined
                                        :key="i"
                                    />
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                    <!-- @unlinkDocument="unlinkDocument($event)" -->
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ** longComments -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="my-2 pa-4"
                >
                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="11">
                            <h3 class="pl-4">Commentaires détaillés</h3>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="commentExpand = !commentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="commentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="longComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="height: auto; border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="createGrossSalaryMatchData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <!-- <v-btn
                                        v-if="(accountingPeriod && accountingPeriod.closed)"
                                        rounded
                                         size="small"

                                        color="primary"
                                        class="btn btn_blue"
                                        disabled
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                         size="small"

                                        color="primary"
                                        class="btn btn_blue"
                                        @click="validated = !validated; adjustmentsExpand = false; upsertAuditCheckResult()"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                         size="small"

                                        color="primary"
                                        class="btn btn_blue"
                                        @click="validated = !validated; upsertAuditCheckResult()"
                                    >
                                        Invalider
                                    </v-btn> -->
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="my-2 pa-4"
                >
                    <v-row no-gutters class="d-flex align-center">
                        <v-col cols="11">
                            <h3 class="pl-4">Commentaires synthétiques</h3>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="height: auto; border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="createGrossSalaryMatchData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>

                <!-- ++ deleteAuditCheckResultDialog -->
                <template v-if="deleteAuditCheckResultDialog">
                    <AuditDeleteAuditCheckResultDialog
                        v-model="deleteAuditCheckResultDialog"
                        :auditCheckResultId="auditCheckResultId"
                        @closed="
                            deleteAuditCheckResultLoading = false;
                            deleteAuditCheckResultDialog = false;
                        "
                        @deletedAcr="deleteAcrDone"
                    />
                    <!-- deleteAuditCheckResultLoading="deleteAuditCheckResultLoading" -->
                </template>

                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="upsertedACR()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->
                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsert="refresh()"
                        :actions="actionsMiscellaneousOperation"
                    />
                </oss-dialog>

                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !acKey || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />

                <!-- :accountingItemType="'MISCELLANEOUS_OPERATION'" -->
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { mathFix } from "../../services/mathServices";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";

import AccountableAccountBalanceDetail from "../AccountableAccountBalanceDetail.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import { CheckBase } from "./CheckBase";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditDeleteAuditCheckResultDialog from "./AuditDeleteAuditCheckResultDialog.vue";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";

import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import { getDBFormattedDate } from "@/services/dateServices";
import { DialogAction } from "@/services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccountBalanceDetail,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AuditDeleteAuditCheckResultDialog,
        AccountingItemEdition2,
    },
})
export class CheckSalaryCommon extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) pathName: string;
    @Prop({ default: "" }) auditName: string;

    loading: boolean = false;
    dataLoading: boolean = true;
    deleteAuditCheckResultLoading: boolean = false;
    // withAccountingPeriod: boolean = false;

    // accountingPeriodEnd: string = ""
    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    noResults: boolean = false;
    validated: boolean = false;

    notFinished: boolean = true;

    showDeleteAcrBtnTooltipMessage: string = "";

    miscellaneousOperationDialog: boolean = false;
    deleteAuditCheckResultDialog: boolean = false;
    dialogAuditCheckDocumentsManager: boolean = false;

    miscellanousOperationData: Array<any> = [];

    longComment: string = "";
    shortComment: string = "";

    commentExpand: boolean = false;
    shortCommentExpand: boolean = false;
    documentsExpand: boolean = false;

    documents: Array<any> = [];
    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    alreadyLinkedDoc: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    // get selectedCompany() {
    //     return this.$store.getters.getCompany(this.companyId);
    // }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    // afterAccountingPeriodFound() {
    //     if (this.accountingPeriod) {
    //             console.log(this.accountingPeriod)
    //             console.log(this.accountingPeriods)
    //             debugger

    //     }
    // }

    // -- look if to delete
    displayLinkedDocument(document) {
        debugger;
        this.dialogAuditCheckDocumentsManager = true;
        this.documentToDisplay = document;
    }

    // addNewDocument(data) {
    //     // ** look if data contains documents
    //     this.connectedDocuments.push(data)
    // }

    // validateNewDocuments(data) {
    //     this.createGrossSalaryMatchData()
    // }

    // selectDocument(document) {
    //     this.connectedDocuments.push(document)
    //     this.createGrossSalaryMatchData()
    // }

    // clearDocument() {
    //     this.documentToDisplay = null
    // }

    // replaceList(data) {
    //     this.connectedDocuments = data
    //     this.documents = undefined
    //     this.createGrossSalaryMatchData()
    // }

    // ++++++++++++++++++ ACCOUNTING LINES and AUDIT CHECK RESULT +++++++++++++
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data.auditItems?.items?.[0]) {
                    this.deleteAuditCheckResultDialog = false;
                    this.deleteAuditCheckResultLoading = false;

                    this.auditItems = JSON.parse(JSON.stringify(data.auditItems.items[0]));

                    // this.accountingPeriod = this.accountingPeriods.find((ap) => ap.id === this.accountingPeriodId);

                    this.accountableAccounts = this.auditItems?.accountableAccounts?.length
                        ? this.auditItems.accountableAccounts
                        : [];

                    if (this.auditItems.auditCheckResult?.id) {
                        this.auditCheckResult = this.auditItems.auditCheckResult;
                        this.auditCheckResultId = this.auditCheckResult.id;

                        // **** data : stored match lines **************
                        if (this.auditCheckResult.data) {
                            this.acrData = this.auditCheckResult.data;

                            // ** long + shortComments
                            if (this.acrData?.globals) {
                                this.longComment = this.acrData.globals.longComment || "";
                                this.shortComment = this.acrData.globals.shortComment || "";
                                this.validated = this.acrData.globals.validated || false;
                            } else {
                                this.longComment = "";
                                this.shortComment = "";
                                this.validated = false;
                            }
                        }

                        const connectedDocuments = this.auditCheckResult.documents;
                        if (connectedDocuments) {
                            this.connectedDocuments = connectedDocuments;
                        }

                        const results = this.auditCheckResult.results;
                        if (results) {
                            this.results = results;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }
                    }
                }
                this.dataLoading = false;
            } else {
                this.initialiseCompany();
            }
        },
    })
    auditItems: any = {};

    accountableAccounts: Array<any> = [];

    acrData: any = {};

    reviewed: number = 0;

    // unlinkDocument(updatedConnectedDocuments) {
    //     this.connectedDocuments = updatedConnectedDocuments
    //     debugger
    //     this.createGrossSalaryMatchData()
    // }

    // ++++++++++++++ UPSERT +++++++++++++++
    async createGrossSalaryMatchData(action = undefined) {
        const data = {
            details: [],
            globals: {
                shortComment: this.shortComment || "",
                longComment: this.longComment || "",
                validated: this.validated || false,
            },
        };

        for (let d = 0; d < this.accountableAccounts.length; d++) {
            const aaAcrData = {
                name: this.accountableAccounts[d].name,
                description: this.accountableAccounts[d].description,
                // totalBalance: this.accountableAccounts[d].totalBalance,
                totalBalanceForReport: this.accountableAccounts[d].totalBalance || 0, // ** to use only for report
                manualAmount: this.accountableAccounts[d].manualAmount || 0,
                // gap: this.accountableAccounts[d].gap,
                gapForReport: this.accountableAccounts[d].gap || 0, // ** to use only for report
                comment: this.accountableAccounts[d].comment || "",
                validated: this.accountableAccounts[d].validated || false,
                expand: this.accountableAccounts[d].expand || false,
                queryLengthForReport: this.accountableAccounts[d].queryLength || 0, // ** to use only for report
            };
            data.details.push(aaAcrData);
        }

        // ** in parent component use this.odToResults + connectResultToACR()
        // if (this.auditCheckResult?.results.length) {
        //     connectedOdsIds = this.auditCheckResult?.results.map(doc => ({id: doc.id}))
        // }

        let auditCheckResultVariables: any = {};

        if (this.acKey && this.companyId && this.accountingPeriodId) {
            auditCheckResultVariables = {
                id: this.auditCheckResultId || "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: this.validated ? "VALIDATED" : "EDITION",
                // thirdPartyCompanyCreate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                // thirdPartyCompanyUpdate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: JSON.parse(JSON.stringify(data)) || undefined,
                // deleteDocuments: this.previousDocumentsIds || undefined, // ** previous results, if to delete
                // documents: [],  // ** results = générés par le contrôle
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                // connectOdsToResults: this.odToResults || undefined,
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
                reviewed: this.reviewed,
            };
        }

        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });
        }

        // await this.createUserActivity(action) // deprecated

        // ++++++++++++++ RESET +++++++++++++++++++
        this.refresh();
    }

    deleteAcrDone() {
        this.deleteAuditCheckResultLoading = false;
        this.deleteAuditCheckResultDialog = false;
        this.refresh();
    }

    refresh() {
        // ++ pass through after $emit upsertedAuditCheckResult in Manager
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger; // git-ignore
        }

        this.initialiseCompany();
    }

    upsertedACR() {
        this.createGrossSalaryMatchData();
        // don't refresh
        // it will cancel accountableAccount.manualAmount & gap
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.createGrossSalaryMatchData("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.createGrossSalaryMatchData("UPDATE");
        }
    }

    // computeAccountingPeriodText(accountingPeriod) {
    //     let text = moment(accountingPeriod.start).format("DD-MM-YYYY");
    //     text += " / ";
    //     text += moment(accountingPeriod.end).format("DD-MM-YYYY");
    //     return text;
    // }

    // get accountingPeriodId() {
    //     if (this.withAccountingPeriod && this.accountingPeriod) return this.accountingPeriod.id
    //     if (this.$route.params.accountingPeriodId) return this.$route.params.accountingPeriodId;
    //     return undefined
    // }

    async fetchTotals(detailledBalanceInfos) {
        if (this.accountableAccounts.length && detailledBalanceInfos.aaName) {
            const indexAA = this.accountableAccounts.findIndex(
                (aa) => aa.name === detailledBalanceInfos.aaName,
            );
            if (indexAA >= 0) {
                this.accountableAccounts[indexAA].queryLength = detailledBalanceInfos.queryLength;

                if (this.accountableAccounts[indexAA].queryLength > 0) {
                    this.accountableAccounts[indexAA].aaName = detailledBalanceInfos.aaName;
                    this.accountableAccounts[indexAA].totalBalance =
                        detailledBalanceInfos.totalBalance;

                    this.changeGap(indexAA);
                } else {
                    this.accountableAccounts[indexAA].validated = true;
                }
            }
            // eslint-disable-next-line no-prototype-builtins
            this.notFinished = this.accountableAccounts.some(
                (accAccount) => !accAccount.hasOwnProperty("queryLength"),
            );
            if (!this.notFinished) {
                // *** if any lines received
                const noQueryLengths = !this.accountableAccounts.some(
                    (accAccount) => accAccount.queryLength > 0,
                );
                if (noQueryLengths) {
                    this.noResults = true;
                }
            }
        } else {
            debugger; // git-ignore
        }
    }

    createRows(accountableAccount) {
        this.miscellanousOperationData = [];

        if (accountableAccount && accountableAccount.gap) {
            const row = {
                date: getDBFormattedDate(this.accountingPeriod.end) || getDBFormattedDate(moment()),
                accountableAccount: { name: "" },
                wording: "",
                netAmount: 0.0,
                debit: 0.0,
                credit: 0.0,
            };

            this.miscellanousOperationData.push(
                JSON.parse(JSON.stringify(row)),
                JSON.parse(JSON.stringify(row)),
            );

            this.miscellanousOperationData[0].accountableAccount.name = accountableAccount.name;
            // this.miscellanousOperationData[1].accountableAccount.name = ""

            if (accountableAccount.gap > 0) {
                this.miscellanousOperationData[0].debit = 0;
                this.miscellanousOperationData[0].credit = accountableAccount.gap;
                if (accountableAccount.gap <= 2) {
                    this.miscellanousOperationData[0].wording =
                        "Regul arrondis c/" + accountableAccount.name;
                    this.miscellanousOperationData[1].wording =
                        "Regul arrondis c/" + accountableAccount.name;
                    this.miscellanousOperationData[1].accountableAccount.name = "658000";
                    this.miscellanousOperationData[1].debit = accountableAccount.gap;
                    this.miscellanousOperationData[1].credit = 0;
                } else {
                    this.miscellanousOperationData[0].wording =
                        "Regul c/" + accountableAccount.name;
                    this.miscellanousOperationData[1].wording =
                        "Regul c/" + accountableAccount.name;
                }
            } else if (accountableAccount.gap < 0) {
                this.miscellanousOperationData[0].debit = -accountableAccount.gap;
                this.miscellanousOperationData[0].credit = 0;
                if (accountableAccount.gap >= -2) {
                    this.miscellanousOperationData[0].wording =
                        "Regul arrondis c/" + accountableAccount.name;
                    this.miscellanousOperationData[1].wording =
                        "Regul arrondis c/" + accountableAccount.name;
                    this.miscellanousOperationData[1].accountableAccount.name = "758000";
                    this.miscellanousOperationData[1].debit = 0;
                    this.miscellanousOperationData[1].credit = -accountableAccount.gap;
                } else {
                    this.miscellanousOperationData[0].wording =
                        "Regul c/" + accountableAccount.name;
                    this.miscellanousOperationData[1].wording =
                        "Regul c/" + accountableAccount.name;
                }
            }
        }
    }

    aaExpand(accountableAccount) {
        accountableAccount.expand = !accountableAccount.expand;
    }

    changeGap(i) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.accountableAccounts?.[i]?.hasOwnProperty("totalBalance")) {
            this.accountableAccounts[i].gap =
                mathFix(
                    this.accountableAccounts[i].totalBalance -
                        this.accountableAccounts[i].manualAmount,
                    2,
                ) || 0;
        } else {
            this.accountableAccounts[i].gap = 0;
        }
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    get disabledBtnGlobalValidation() {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (this.accountableAccounts?.length) {
            if (!this.notFinished && !this.noResults) {
                const filteredAccountableAccounts = this.accountableAccounts.filter(
                    (aa) => aa.queryLength > 0,
                );
                if (filteredAccountableAccounts?.length) {
                    let upsertToDo = false;
                    for (const faa of filteredAccountableAccounts) {
                        if (faa.validated && faa.gap) {
                            if (faa.gap >= 2 || faa.gap <= -2) {
                                faa.validated = false;
                                upsertToDo = true;
                            }
                        } else if (!faa.gap && !faa.validated) {
                            faa.validated = true;
                            upsertToDo = true;
                        }
                    }

                    const gapAccountableAccount = filteredAccountableAccounts.some(
                        (faa) => faa.gap && (faa.gap > 2 || faa.gap < -2),
                    );
                    if (gapAccountableAccount) {
                        if (this.validated) {
                            this.validated = false;
                            upsertToDo = true;
                        }
                        // if (upsertToDo) {
                        //     this.createGrossSalaryMatchData()
                        // }
                        return true;
                    }
                    // if (upsertToDo) {
                    //     this.createGrossSalaryMatchData()
                    // }
                }
            }
        }

        return false;
    }

    initialiseCompany() {
        this.accountableAccounts = [];
        this.auditCheckResult = [];
        this.miscellanousOperationData = undefined;
        this.miscellaneousOperationDialog = false;
        this.notFinished = true;
        this.documents = [];
    }

    get showDeleteAcrBtnIfRecovery() {
        if (this.auditCheckResult?.id) {
            if (this.closedPeriod) {
                this.showDeleteAcrBtnTooltipMessage = "Exercice N clôturé";
                return false;
            }
            return true;
        }
        this.showDeleteAcrBtnTooltipMessage = "Aucun contrôle";
        return false;
    }
}

export default toNative(CheckSalaryCommon);
</script>
